import { createBrowserRouter } from 'react-router-dom'

import { routes } from './route-tree'

// The tree itself lives in `route-tree.tsx`, as data, so it can be asserted
// without a DOM — `createBrowserRouter` reads `window.history` here and now,
// and the frontend suite runs in `environment: 'node'`.
export const router = createBrowserRouter(routes)
